import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { RenderIf } from '../../utils/RenderIf';
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { Badge } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import Select from 'react-select';
import { CatalogsFetchAPI } from '../../../api/Catalogs';
import { CategoriesDashFetchAPI } from '../../../api/CategoriesDash';
import HoursList from '../../utils/HoursList';
//Icons
import eye from '../../img/icons/eye.png'
import on from '../../img/icons/on.png'
import off from '../../img/icons/off.png'
import trash from '../../img/icons/delete.png'

function ModalEditAndViewCatalog({ catalogsDetails, getCatalogById, catalog, branchoffice_id, categoriesByCatalog, eventHandlerEdit, setEventHandlerEdit }) {

    const hours = HoursList();
    const [showModal, setShowModal] = useState(false)
    const [showModalAsing, setShowModalAsing] = useState(false)
    const [taxes_list, setTaxes_list] = useState([])
    const [categorySelectNow, setCategorySelectNow] = useState(0)
    const [categoriesSelect, setCategoriesSelect] = useState([])
    const [edit, setEdit] = useState(false)




    let token = localStorage.getItem("x-access-token")
    let user = JSON.parse(localStorage.getItem('user'))


    //Params data group or product
    const [name, setName] = useState(catalogsDetails.name);
    const [minHour, setMinHour] = useState(catalogsDetails.minHour)
    const [maxHour, setMaxHour] = useState(catalogsDetails.maxHour)

    const getCategoriesByBusiness = async () => {
        user = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await CategoriesDashFetchAPI.getCategoriesByBusiness(user.business_id, token)

            console.log(response.data.data);
            let categorieInfo = []
            response.data.data.forEach(category => {
                categorieInfo.push({ value: category.category_id, label: category.category_name })
            });

            setCategoriesSelect(categorieInfo)
        } catch (err) {
            console.log(err)
        }
    }

    const assingCategoryToCatalog = async () => {

        let data = { "category_id": categorySelectNow }

        try {
            const response = await CatalogsFetchAPI.assignCategoriesToCatalog(data, catalogsDetails.catalog_id, token);
            ErrorAlert("", "Categoria asignada correctamente", "success");
            getCatalogById(catalogsDetails.catalog_id)
            setShowModalAsing(false)

        } catch (err) {
            ErrorAlert("", "No fue posible asignar la categoria", "error");
            console.log(err);
        }
    }

    const handleSaveTableSelect = (option) => {
        setCategorySelectNow(option.value);
    }

    const deleteCategorytoCatalog = async (category_id) => {
        let data = { "categories": [{ "category_id": category_id }] }
        try {
            const response = await CatalogsFetchAPI.deleteCategoriesToCatalog(data, catalogsDetails.catalog_id, token);
            ErrorAlert("", "Categoria eliminada correctamente", "success");
            getCatalogById(catalogsDetails.catalog_id)

        } catch (err) {
            ErrorAlert("", "No fue posible remover la categoria", "error");
            console.log(err);
        }
    }

    const updateCatalog = async (data) => {
        try {
            const response = await CatalogsFetchAPI.updateCatalog(data, catalogsDetails.catalog_id, token)
            const responseDataDetails = await CatalogsFetchAPI.updateBranchCatalog(data, branchoffice_id, token)

            
            getCatalogById(catalogsDetails.catalog_id)
            setEdit(false)
        } catch (err) {
            ErrorAlert("", "No fue posible actualizar el catalogo", "error");
            console.log(err);
        }
    }


    const updateCatalogDetails = () => {
        let data = {
            "catalog_id": catalogsDetails.catalog_id,
            "status": catalogsDetails.status,
            "name": name,
            "minHour": minHour,
            "maxHour": maxHour,
            "monday": catalogsDetails.monday,
            "tuesday": catalogsDetails.tuesday,
            "wednesday": catalogsDetails.wednesday,
            "thursday": catalogsDetails.thursday,
            "friday": catalogsDetails.friday,
            "saturday": catalogsDetails.saturday,
            "sunday": catalogsDetails.sunday
        }
        updateCatalog(data)
    }


    //Function to update the catalog on the branch office
    const updateDayAttention = async (e) => {
        //e.preventDefault();
        //Variable
        let status = 1;
        
        //We get the catalog stats
        if (e.target.checked == false) {
            status = 0
        } else {
            status = 1
        }
        //data to send
        let data = {
            "catalog_id": catalogsDetails.catalog_id,
            "status": catalogsDetails.status,
            "name": catalogsDetails.name,
            "minHour": catalogsDetails.minHour,
            "maxHour": catalogsDetails.maxHour,
            "monday": catalogsDetails.monday,
            "tuesday": catalogsDetails.tuesday,
            "wednesday": catalogsDetails.wednesday,
            "thursday": catalogsDetails.thursday,
            "friday": catalogsDetails.friday,
            "saturday": catalogsDetails.saturday,
            "sunday": catalogsDetails.sunday
        }

        switch (e.target.id) {
            case `lunes`:
                data.monday = status
                break;
            case `martes`:
                data.tuesday = status
                break;
            case `miercoles`:
                data.wednesday = status
                break;
            case `jueves`:
                data.thursday = status
                break;
            case `viernes`:
                data.friday = status
                break;
            case `sabado`:
                data.saturday = status
                break;
            case `domingo`:
                data.sunday = status
                break;
        }

        updateCatalog(data)
    }


    useEffect(() => {
        setEventHandlerEdit(0)
    }, [eventHandlerEdit])



    return (
        <>


            <button className='btn btn-outline-dark btn-sm border-0'
                onClick={async () => { setShowModal(true); getCatalogById(branchoffice_id == 0 ? catalog.id : catalog.catalog_id); getCategoriesByBusiness() }}
            >
                <i className="uil uil-pen"></i>
            </button>

            <Modal
                show={showModal}
                onHide={() => (setShowModal(false))}
                size='md'
                centered>

                <Modal.Body>

                    <div className='position-relative'>
                        <h2 className="title-main-login  text-center ">
                            Editar catalogo
                        </h2>
                    </div>

                    <div>
                        <Col>
                            <div className='mt-3'>

                                <ListGroup as="ol" >

                                    <Form className="needs-validation">

                                        <Form.Group className="mb-3" controlId="name"></Form.Group>
                                        <ListGroup.Item
                                            as="li"
                                            className="d-flex justify-content-center align-items-start"
                                        ><button type="button" className='btn btn-outline-primary pulse rounded-3 p-2 lh-1 border'
                                            onClick={() => (edit == false ? setEdit(true) : setEdit(false))}
                                        ><i class="uil uil-edit"> Editar producto</i>
                                            </button></ListGroup.Item>

                                        <ListGroup.Item
                                            as="li"
                                            className="d-flex justify-content-between align-items-start">

                                            {edit == false ? <><div className="ms-2 me-auto">
                                                <div className="fw-bold">Nombre</div>
                                                {catalogsDetails.name}
                                            </div></> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="name">
                                                <Form.Label>Nombre</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={name}
                                                    placeholder={catalogsDetails.name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    name="name"
                                                />
                                            </Form.Group></div>}

                                        </ListGroup.Item>
                                        <ListGroup.Item
                                            as="li"
                                            className="d-flex justify-content-between align-items-start"
                                        >

                                            {edit == false ? <><div className="ms-2 me-auto">
                                                <div className="fw-bold">Hora Inicio</div>
                                                {catalogsDetails.minHour}
                                            </div></> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="minHour" onChange={(e) => setMinHour(e.target.value)}>
                                                <Form.Label>Hora Inicio</Form.Label>

                                                <Form.Select aria-label="" name="minHour" >
                                                    {hours.map((hour) => (<><option value={hour.value}>{hour.label}</option></>))}
                                                </Form.Select>
                                            </Form.Group></div>}

                                        </ListGroup.Item>
                                        <ListGroup.Item
                                            as="li"
                                            className="d-flex justify-content-between align-items-start"
                                        >

                                            {edit == false ? <><div className="ms-2 me-auto">
                                                <div className="fw-bold">Hora Inicio</div>
                                                {catalogsDetails.maxHour}
                                            </div></> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="maxHour" onChange={(e) => setMaxHour(e.target.value)}>
                                                <Form.Label>Hora fin</Form.Label>

                                                <Form.Select aria-label="" name="maxHour">
                                                    {hours.map((hour) => (<><option value={hour.value}>{hour.label}</option></>))}
                                                </Form.Select>
                                            </Form.Group></div>}

                                        </ListGroup.Item>

                                        <RenderIf isTrue={edit == true}>
                                            <ListGroup.Item
                                                as="li"
                                                className="d-flex justify-content-between align-items-start"
                                            >
                                                <div className="mt-3 d-flex justify-content-end">
                                                    <Button size="sm" variant="danger" type="button" onClick={() => setEdit(false)}>
                                                        Cancelar
                                                    </Button>
                                                </div>
                                                <div className="mt-3 d-flex justify-content-end">
                                                    <Button size="sm" variant="success" type="button" onClick={() => { updateCatalogDetails() }}>
                                                        Guardar
                                                    </Button>
                                                </div>
                                            </ListGroup.Item>
                                        </RenderIf>
                                    </Form>


                                    <ListGroup.Item
                                        as="li"
                                        className="d-flex justify-content-between align-items-start"
                                    >
                                        <div className='mt-3'>
                                            <div className="ms-2 me-auto">
                                                <div className="fw-bold">Dias de atencion</div>
                                                <div className='row d-flex justify-content-center align-items-center '>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`lunes`}
                                                            label=""
                                                            checked={catalogsDetails.monday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Lunes</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`martes`}
                                                            label=""
                                                            checked={catalogsDetails.tuesday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Martes</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`miercoles`}
                                                            label=""
                                                            checked={catalogsDetails.wednesday === 1 ? true : false} 
                                                            onChange={(e) =>updateDayAttention(e)}/>

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Miercoles</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`jueves`}
                                                            label=""
                                                            checked={catalogsDetails.thursday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Jueves</div>
                                                        </div>
                                                    </div>
                                                    <div className=" col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`viernes`}
                                                            label=""
                                                            checked={catalogsDetails.friday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Viernes</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`sabado`}
                                                            label=""
                                                            checked={catalogsDetails.saturday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Sabado</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-between align-items-start rounded-2  p-2 align-items-center gap-2 mt-2 bg-white border-dashed">
                                                        <Form.Switch
                                                            type="switch"
                                                            id={`domingo`}
                                                            label=""
                                                            checked={catalogsDetails.sunday === 1 ? true : false}
                                                            onChange={(e) =>updateDayAttention(e)} />

                                                        <div className="ms-2 me-auto">
                                                            <div className="fw-bold text-wrap">Domingo</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div></ListGroup.Item>

                                </ListGroup>


                            </div>
                        </Col>


                        <Col>
                            <div className='mt-3'>

                                <ListGroup as="ol" >

                                    {/** Categories */}
                                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" >
                                        <div className="ms-2 me-auto">
                                            <div className="fw-bold">Categorias
                                                <button className='btn btn-primary btn-sm border-0 m-2' onClick={() => setShowModalAsing(true)}>
                                                    <i className="uil uil-plus">Agregar categoria</i>
                                                </button>
                                            </div>
                                            <ListGroup as="ol" >
                                                {categoriesByCatalog.map((category) => (
                                                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                                        <div className="ms-2 me-auto" >
                                                            {category.name}
                                                            <button className='btn btn-outline-danger btn-sm border-0' onClick={() => deleteCategorytoCatalog(category.category_id)} >
                                                                <i className="uil uil-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </ListGroup.Item>
                                                ))}
                                            </ListGroup>
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>
                        </Col>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setShowModal(false))}>Cerrar</Button>
                </Modal.Footer>
            </Modal >

            {/*Modal add category to product*/}
            <Modal
                show={showModalAsing}
                onHide={() => (setShowModalAsing(false))}
                size='large'
                centered>
                <Modal.Header>
                    <h3><i className="uil uil-plus"></i>Asignar Categoria</h3>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex justify-content-center align-item-center'>
                        <Select
                            name="user_branch" id="user_branch"
                            className='w-100 m-3'
                            options={categoriesSelect}
                            onChange={handleSaveTableSelect}
                        />
                        <Button size="sm" variant="success" type="button" className='m-3' onClick={async () => assingCategoryToCatalog()}>
                            Guardar
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setShowModalAsing(false))}>Cerrar</Button>
                </Modal.Footer>
            </Modal>



        </>
    )
}

export default ModalEditAndViewCatalog